import type { UiSchemaJson } from '../types/uiSchema';

export type StudioPreSaveValidator = (formSchema: Record<string, unknown>, uiSchema: UiSchemaJson) => string[];
export type StudioPostGenerateMutator = (formSchema: Record<string, unknown>, uiSchema: UiSchemaJson) => UiSchemaJson;

class StudioPluginRegistry {
  private preSaveValidators: StudioPreSaveValidator[] = [];
  private postGenerateMutators: StudioPostGenerateMutator[] = [];

  registerPreSaveValidator(fn: StudioPreSaveValidator): void {
    this.preSaveValidators.push(fn);
  }

  registerPostGenerateMutator(fn: StudioPostGenerateMutator): void {
    this.postGenerateMutators.push(fn);
  }

  runPreSaveValidators(formSchema: Record<string, unknown>, uiSchema: UiSchemaJson): string[] {
    return this.preSaveValidators.flatMap((fn) => {
      try {
        return fn(formSchema, uiSchema) || [];
      } catch {
        return ['Studio validator plugin failed'];
      }
    });
  }

  runPostGenerateMutators(formSchema: Record<string, unknown>, uiSchema: UiSchemaJson): UiSchemaJson {
    return this.postGenerateMutators.reduce((acc, fn) => {
      try {
        return fn(formSchema, acc) || acc;
      } catch {
        return acc;
      }
    }, uiSchema);
  }
}

export const studioPluginRegistry = new StudioPluginRegistry();

